import { render } from "./RecoverPassword.vue?vue&type=template&id=298c2872&scoped=true"
import script from "./RecoverPassword.vue?vue&type=script&lang=js"
export * from "./RecoverPassword.vue?vue&type=script&lang=js"

import "./RecoverPassword.vue?vue&type=style&index=0&id=298c2872&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298c2872"]])

export default __exports__